import { embedText, chunkText } from './embeddingService';
import * as scrapeApi from './scrapeService';
import { accountId, useScrapeStore } from '../store/scrapeStore';

/* ---- URL → scrape (CF Worker) → embed (local Ollama) → Vectorize + D1 ---- */
export async function submitUrlForTraining(url, projectId) {
    const st = useScrapeStore.getState();
    st.setTraining({ running: true, message: 'Scraping URL…', error: '' });
    try {
        const { title, text } = await scrapeApi.scrapeUrl(url);
        st.setTraining({ message: 'Vectorizing via Ollama proxy gateway…' });
        const chunks = chunkText(text);
        if (!chunks.length) throw new Error('Nothing vectorizable extracted from that URL.');
        let n = 0;
        for (const c of chunks) {
            const vector = await embedText(c);
            await scrapeApi.ingest({
                account_id: accountId(), project_id: projectId,
                source: 'scrape', title, body: c, vector, url,
            });
            n++;
        }
        st.pushUrl(url);
        st.setTraining({ running: false, message: `Indexed ${n} chunk${n === 1 ? '' : 's'} → Vectorize (account-scoped).` });
        return { ok: true, chunks: n };
    } catch (err) {
        st.setTraining({ running: false, error: err.message });
        return { ok: false, error: err.message };
    }
}

/* ---- Command Bar amplification: embed prompt → search account namespace ---- */
export async function amplify(prompt, projectId) {
    try {
        const vector = await embedText(prompt);
        const { matches } = await scrapeApi.queryKnowledge({ account_id: accountId(), vector });
        const context = (matches || [])
            .slice(0, 6)
            .map((m, i) => `[${i + 1}] (${m.source}, score ${Number(m.score).toFixed(2)}) ${m.title || ''}\n${(m.body || '').slice(0, 300)}`)
            .join('\n\n');
        useScrapeStore.getState().setAmplified({ context, matches: matches || [] });
        return context;
    } catch {
        useScrapeStore.getState().setAmplified({ context: '', matches: [] });
        return '';
    }
}

/* ---- Relational tracking of a user viewport modification ---------------- */
export async function recordMutation(projectId, action, payload) {
    try {
        await scrapeApi.logMutation({ account_id: accountId(), project_id: projectId, action, payload });
    } catch (err) {
        console.warn('[Scrape-to-CAD] mutation not synced (offline/not configured):', err.message);
    }
}

/* ---- Test the Cloudflare Worker from the Settings UI -------------------- */
export async function checkLearningWorker() {
    const st = useScrapeStore.getState();
    st.setTesting(true); st.setConnected(false);
    try {
        const ok = await scrapeApi.testConnection();
        st.setConnected(ok);
        return ok;
    } catch {
        st.setConnected(false);
        return false;
    } finally {
        st.setTesting(false);
    }
}